"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var __1 = require("../..");
var utils_1 = require("../../utils");
var _2 = require(".");
var AttendeesDayPassField = /** @class */ (function (_super) {
    __extends(AttendeesDayPassField, _super);
    function AttendeesDayPassField(api, eventId, attendeesDayPasses, key, label, isRequired, requiredMessage) {
        if (requiredMessage === void 0) { requiredMessage = 'Date is required'; }
        var _this = _super.call(this, __1.FieldType.AttendeeDayPass, key, label, isRequired, null, requiredMessage) || this;
        _this.api = api;
        _this.eventId = eventId;
        _this.attendeesDayPasses = attendeesDayPasses;
        _this.key = key;
        _this.focused = function () {
            if (_this.isDisabled) {
                return;
            }
            _this._dropdownOpen = true;
            _this.observationProvider.notifyObservers(_1.FieldActions.DropdownOpened);
        };
        _this.blurred = function () {
            _this._dropdownOpen = false;
            _this.observationProvider.notifyObservers(_1.FieldActions.DropdownClosed);
        };
        _this.loadOptions = function () { return __awaiter(_this, void 0, void 0, function () {
            var meetingDates, initialDates, _i, meetingDates_1, date, formatted;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.api.getMeetingDates(this.eventId)];
                    case 1:
                        meetingDates = (_c.sent())
                            .sort(function (a, b) { return new Date(a).getTime() - new Date(b).getTime(); });
                        initialDates = (_b = (_a = this._initialValues) === null || _a === void 0 ? void 0 : _a.map(function (v) { return v.dayPassDate; })) !== null && _b !== void 0 ? _b : [];
                        for (_i = 0, meetingDates_1 = meetingDates; _i < meetingDates_1.length; _i++) {
                            date = meetingDates_1[_i];
                            formatted = utils_1.DateUtils.formatDate(date, utils_1.DateFormats.MMDDYYYY);
                            this._options.push({
                                dayPassEnabled: this._isDayPassEnabled,
                                dayPassDate: formatted,
                                selected: initialDates.indexOf(formatted) >= 0
                            });
                        }
                        this._optionsLoaded = true;
                        this.observationProvider.notifyObservers(_1.FieldActions.OptionsLoaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this._isDayPassEnabled = attendeesDayPasses.length > 0 ?
            attendeesDayPasses[0].dayPassEnabled :
            false;
        _this._initialValues = attendeesDayPasses;
        _this.observationProvider.observe(_this.focused, _1.FieldActions.Focus);
        _this.observationProvider.observe(_this.blurred, _1.FieldActions.Blured);
        _this._options = [];
        _this._loadingPromise = _this.loadOptions();
        return _this;
    }
    Object.defineProperty(AttendeesDayPassField.prototype, "dropdownOpen", {
        get: function () {
            return this._dropdownOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttendeesDayPassField.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttendeesDayPassField.prototype, "selectedMeetingDates", {
        //TODO:: selectedMeetingDates -> selectedDayPassDates
        get: function () {
            return this._options.filter(function (option) { return option.selected === true; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttendeesDayPassField.prototype, "isDayPassEnabled", {
        get: function () {
            return this._isDayPassEnabled;
        },
        enumerable: false,
        configurable: true
    });
    AttendeesDayPassField.prototype.isValid = function () {
        var validStatus = true;
        if (this._isDayPassEnabled)
            validStatus = this.selectedMeetingDates.length > 0;
        this.setIsValid(validStatus);
        return validStatus;
    };
    Object.defineProperty(AttendeesDayPassField.prototype, "errorMessage", {
        get: function () {
            return this.getErrorMessage();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AttendeesDayPassField.prototype, "value", {
        get: function () {
            var _this = this;
            this.selectedMeetingDates.forEach(function (element) {
                element.dayPassEnabled = _this._isDayPassEnabled;
            });
            return this.selectedMeetingDates;
        },
        enumerable: false,
        configurable: true
    });
    AttendeesDayPassField.prototype.setValue = function (value) {
        this._options.forEach(function (option) {
            option.selected = value.some(function (v) { return v.dayPassDate === option.dayPassDate; });
        });
        this.observationProvider.notifyObservers(_1.FieldActions.ValueChanged);
    };
    // public setValue(value: AttendeesDayPassFieldOption[]): void {
    //     if (this._optionsLoaded) {
    //         this.proceedToSetValue(value);
    //     } else {
    //         this.loadingPromise
    //             .then(() => {
    //                 this.proceedToSetValue(value);
    //     });        
    //     }
    // }
    AttendeesDayPassField.prototype.proceedToSetValue = function (value) {
        this._options.forEach(function (option) {
            option.selected = value.some(function (v) { return v.dayPassDate === option.dayPassDate; });
        });
        this.observationProvider.notifyObservers(_1.FieldActions.ValueChanged);
    };
    AttendeesDayPassField.prototype.toggleSelection = function (option) {
        option.selected = !option.selected;
        this.observationProvider.notifyObservers(_1.FieldActions.ValueChanged);
    };
    AttendeesDayPassField.prototype.toggleDayPass = function (value) {
        this._isDayPassEnabled = value;
        this.observationProvider.notifyObservers(_1.FieldActions.ValueChanged);
    };
    Object.defineProperty(AttendeesDayPassField.prototype, "loadingPromise", {
        get: function () {
            return this._loadingPromise;
        },
        enumerable: false,
        configurable: true
    });
    return AttendeesDayPassField;
}(_2.BaseField));
exports.default = AttendeesDayPassField;
